'use strict';

/**
 * Component for the prices
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/components/field-monetary-value.hbs');

var MonetaryValueComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    ui: {
        'currency': 'select',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        var field = this.getOption('field');

        // Render select fields
        this.renderSelectOptions(
            this.ui.currency,
            App.radio().request('currencies:collection'),
            'key',
            'shortName',
            function(option) {
                return this.model && this.model.get(field.unitField) === option.value
            }.bind(this)
        );
    },

    /**
     * Triggerd, when component is shown
     */
    onShow: function() {
        this.reset();
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        data[field.name] = this.$('[name="' + field.name + '"]').val().trim();
        data[field.unitField] = this.$('[name="' + field.unitField + '"]').val().trim();

        return data;
    },
});

module.exports = MonetaryValueComponent;